import { Discipline } from "./Discipline";

const E_MISSING_VALUE = "Värde saknas";
const E_INCORRECT_SPREAD = "Träffarna inte fördelade korrekt";
const E_TOO_MANY_HITS = "För många träffar";
const E_INVALID_SCORE = "Ogiltigt värde";

class PrecisionScoring {
	static validateScore(participant, event, stage) {
		participant.error = null;
		let score = participant.getScores(stage);
		if (score == null || score.values.length < 5 || score.values.some(s => s === null || s === undefined)) {
			participant.error = E_MISSING_VALUE;
			return false;
		}
		if (score.values.some(s => s !== 'X' && typeof (s) !== "number")) {
			participant.error = E_INVALID_SCORE;
			return false;
		}
		return true;
	}

	static total(participant, event) {
		return 0;
	}
}

class FieldScoring {
	static validateScore(participant, event, stage) {
		let stageDef = event.stages.find(s => s.num === stage);
		participant.error = null;
		let score = participant.getScores(stage);
		if (score == null) {
			participant.error = E_MISSING_VALUE;
			return false;
		}
		let length = stageDef.targets + (stageDef.value ? 1 : 0);
		let values = score.values;
		if (values.length < length) {
			participant.error = E_MISSING_VALUE;
			return false;
		} else for (let t = 0; t < length; t++) {
			if (values[t] == null) {
				participant.error = E_MISSING_VALUE;
				return false;
			}
		}
		if (stageDef.min > 0) {
			let max = stageDef.shots + values.filter(t => t < stageDef.min).map(t => t - stageDef.min).reduce((a, b) => a + b, 0);
			if (values.reduce((a, b) => a + b, 0) > max) {
				participant.error = E_INCORRECT_SPREAD;
				return false;
			}
		}
		values = values.slice(0, stageDef.targets);
		if (values.some(t => t > stageDef.max) || values.reduce((a, b) => a + b, 0) > stageDef.shots) {
			participant.error = E_TOO_MANY_HITS;
			return false;
		}
		return true;
	}

	static total(participant, event) {

	}
}

class PointFieldScoring extends FieldScoring {
	static total(participant, event) {
		return 0;
	}
}

class RapidFinalScoring {
	static validateScore(participant, event, stage) {
		participant.error = null;
		let score = participant.getScores(stage);
		if (score == null || score.values.length < 5 || score.values.some(s => s === null || s === undefined || s === "-")) {
			participant.error = E_MISSING_VALUE;
			return false;
		}
		if (score.values.some(s => typeof (s) !== "number" || s < -1 || s > 1)) {
			participant.error = E_INVALID_SCORE;
			return false;
		}
		return true;
	}

	static total(participant, event) {
		return 0;
	}
}

export class ScoringModels {
	static getModel(discipline) {
		switch (discipline) {
			case Discipline.target:
			case Discipline.sport5:
			case Discipline.sport10:
				return PrecisionScoring;
			case Discipline.fieldP:
			case Discipline.fieldK:
				return FieldScoring;
			case Discipline.scoredP:
			case Discipline.scoredK:
				return PointFieldScoring;
			case Discipline.rapidFinal:
				return RapidFinalScoring;
			default:
				return null;
		}
	}
}